var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn btn-save', { 'highlight': _vm.colorChanged }],attrs:{"type":"submit"},on:{"click":_vm.save}},[_vm._v("Save")])}
var staticRenderFns = []

export { render, staticRenderFns }